/* eslint-disable react/jsx-no-constructed-context-values */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

export const PropertyContext = React.createContext();

export default function PropertyContextProvider(props) {
  const { children } = props;
  const [propertyCreation, setPropertyCreation] = useState({});
  const [showSubmitBtn, setShowSubmitBtn] = useState(false);
  const [isNextBtnClick, setIsNextBtnClick] = React.useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [taskState, setTaskState] = useState(false);
  const [displayExchange, setDisplayExchange] = useState(true);

  const [isBinderChatOpen, setIsBinderChatOpen] = useState(false);
  const [winerPublishdMoveToEnded, setWinerPublishdMoveToEnded] =
    useState(false);
  const [winnerPopper, setwinnerPopper] = useState(false);
  const [openManageOfferFromVendorStatus, setOpenManageOfferFromVendorStatus] =
    useState({
      open: false,
      buyerId: null,
    });

  const restContext = () => {
    setPropertyCreation({});
  };

  const [isScrolling, setIsScrolling] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  let scrollTimeout = null;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScrollTop < lastScrollTop) {
        setIsScrolling(false);
      } else {
        setIsScrolling(true);
      }

      setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);

      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }

      scrollTimeout = setTimeout(() => {
        setIsScrolling(true);
      }, 500);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    };
  }, [lastScrollTop]);

  return (
    <PropertyContext.Provider
      value={{
        winerPublishdMoveToEnded,
        setWinerPublishdMoveToEnded,
        isBinderChatOpen,
        setIsBinderChatOpen,
        winnerPopper,
        setwinnerPopper,
        showSubmitBtn,
        displayExchange,
        setDisplayExchange,
        setIsNextBtnClick,
        isNextBtnClick,
        setShowSubmitBtn,
        propertyCreation,
        setPropertyCreation,
        restContext,
        collapsed,
        setCollapsed,
        taskState,
        setTaskState,
        isScrolling,
        openManageOfferFromVendorStatus,
        setOpenManageOfferFromVendorStatus,
      }}
    >
      {children}
    </PropertyContext.Provider>
  );
}

PropertyContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
